module.exports = __webpack_public_path__ + "static/img/bottom-ac-pilot.2ed36d79.png";